import { useCurrentPathMatch } from "hooks/useCurrentPathMatch";
import type React from "react";
import { Fragment } from "react";
import useBreadcrumbs from "use-react-router-breadcrumbs";
import type { BreadcrumbsProps } from "./Breadcrumbs.model";
import { StyledBreadcrumbLink, StyledBreadcrumbs } from "./Breadcrumbs.styled";

export const Breadcrumbs: React.FC<BreadcrumbsProps> = ({
  className,
  routes = [],
  excludeRoutes = [],
  showAllRoutes = true,
  dataCy,
  divider = ">",
}) => {
  const { currentRouteMatches } = useCurrentPathMatch();
  const breadcrumbs = useBreadcrumbs(routes, {
    disableDefaults: !showAllRoutes,
    excludePaths: excludeRoutes,
  });

  const isActivePath = (pathname: string) => currentRouteMatches(pathname);

  return (
    <StyledBreadcrumbs className={className} data-cy={dataCy}>
      {breadcrumbs.map(({ breadcrumb, match, key }, index) => (
        <Fragment key={key}>
          <StyledBreadcrumbLink
            $active={isActivePath(match.pathname)}
            data-cy={dataCy ? `${dataCy}-link` : "breadcrumbs-link"}
            to={match.pathname || ""}
          >
            {breadcrumb}
          </StyledBreadcrumbLink>
          {/* -- Append divider except on last item -- */}
          {index < breadcrumbs.length - 1 && divider}
        </Fragment>
      ))}
    </StyledBreadcrumbs>
  );
};
